import { render, staticRenderFns } from "./SuperAdminGames.vue?vue&type=template&id=3152b3dc&"
import script from "./SuperAdminGames.vue?vue&type=script&lang=js&"
export * from "./SuperAdminGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports